let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("joexP")).then(() => parcelRequire('6DM0x'));